
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.75 30.25v-30h30v30z"}}),_c('path',{attrs:{"d":"M15.75 14.934a3.155 3.155 0 110-6.31 3.155 3.155 0 010 6.31zm0-12.304a8.828 8.828 0 00-8.834 8.834c0 2.196.63 4.253 1.78 6.108 1.198 1.944 2.776 3.61 3.987 5.553.593.946 1.023 1.83 1.477 2.852.328.694.593 1.893 1.59 1.893.997 0 1.262-1.199 1.578-1.893.466-1.022.883-1.906 1.476-2.852 1.212-1.93 2.79-3.597 3.988-5.553 1.161-1.855 1.792-3.912 1.792-6.108A8.828 8.828 0 0015.75 2.63z","fill":"#FFF"}})])])
          )
        }
      }
    